import { initCartPanelScrollPatch } from './cartPanelScroll';
import { initCompanyLocationGalleryPatch } from './companyLocationGallery';
import { initFeaturedCatalogPatches, registerFeaturedNetworkPatch } from './featuredCatalog';

export function registerLegacyPreloadPatches(): void {
  // Deve girare prima del caricamento del bundle legacy, perché intercetta le fetch prodotti.
  registerFeaturedNetworkPatch();
}

export function initLegacyDomPatches(): void {
  initFeaturedCatalogPatches();
  initCartPanelScrollPatch();
  initCompanyLocationGalleryPatch();
}
